import httpClient from 'utility/httpClient.util'
import cloneDeep from 'clone-deep'
import { applyRequestTimeout, withRequestTimeout } from './RequestTimeout'

// Allow the design service to start on the first request after being idle.
export const FORM_DESIGN_REQUEST_TIMEOUT = 30000

export const requestFormDesign = async (formCode) => {
  const action = { timeout: FORM_DESIGN_REQUEST_TIMEOUT }
  const api = `/designer/form-design/getByCode?code=${formCode}`
  const response = await withRequestTimeout(
    httpClient.get(api, applyRequestTimeout({}, action)),
    action,
  )
  const formDesign = response?.data?.data
  if (!formDesign?.code || !formDesign?.jsonData) {
    throw new Error(`Unable to load form design: ${formCode}`)
  }
  // Consumers remove jsonData while building their context; isolate shared cache responses.
  return cloneDeep(formDesign)
}
